import { groupHoldAuditsByProgram, rpmActiveDuringPeriod, ymdLocal } from './rpmCensusUtils';

/**
 * Patients with an Active RPM status (enrolled, not on hold) on at least one day
 * of the period. Each returned patient carries `rpmPeriod` (first/last active
 * day) so callers can evaluate as-of attributes within the patient's RPM window.
 *
 * @returns {Array<object>} shallow copies of the qualifying patients
 */
export function filterRpmPeriodCohort({ patients, programsByPatientId, holdAudits, period }) {
  const startYmd = ymdLocal(period?.start);
  const endYmd = ymdLocal(period?.end);
  if (!startYmd || !endYmd || !Array.isArray(patients)) return [];
  const auditsByProgram = groupHoldAuditsByProgram(holdAudits);
  const out = [];
  patients.forEach((patient) => {
    if (!patient?.id) return;
    const programs = programsByPatientId?.get?.(patient.id) || [];
    const window = rpmActiveDuringPeriod(programs, auditsByProgram, patient.id, startYmd, endYmd);
    if (window.active) out.push({ ...patient, rpmPeriod: window });
  });
  return out;
}

/** Cohort rule wording shared by sheets, footnotes, CSV preambles, and the explainer. */
export const RPM_PERIOD_COHORT_NOTE =
  'Patients with an Active RPM status (enrolled and not on hold) on at least one day of the period.';
